// Everything the app shows lives on the phone first (HANDOVER §2).
import Dexie, { type EntityTable } from 'dexie'
import type { ClientEvent, ServerEvent } from '../../shared/events'

/** An event as stored locally: ours (maybe not yet synced) or pulled from the server. */
export interface StoredEvent extends ClientEvent {
  personId: string
  /** Server sequence number once synced. */
  seq?: number
}

/** A queued event, with who made it (only that person's session may push it). */
export interface OutboxEvent extends ClientEvent {
  /** Missing on events queued by older versions; those go with whoever syncs next. */
  personId?: string
}

export interface KV {
  key: string
  value: unknown
}

export class QuestDB extends Dexie {
  kv!: EntityTable<KV, 'key'>
  events!: EntityTable<StoredEvent, 'id'>
  outbox!: EntityTable<OutboxEvent, 'id'>

  constructor(name = 'travel-quest') {
    super(name)
    this.version(1).stores({
      kv: 'key',
      events: 'id, at, type, seq',
      outbox: 'id, at',
    })
  }
}

export let db = new QuestDB()

/** Tests swap in a fresh database. */
export function useDatabase(next: QuestDB) {
  db = next
}

export async function kvGet<T>(key: string): Promise<T | undefined> {
  return (await db.kv.get(key))?.value as T | undefined
}

export async function kvSet(key: string, value: unknown): Promise<void> {
  await db.kv.put({ key, value })
}

export type { ServerEvent }
